<div
  *ngIf="visible"
  class="flex items-center justify-between gap-3 mb-4 px-4 py-3 rounded-md bg-amber-100 border border-amber-300 text-amber-900"
  role="status"
>
  <div class="flex items-center gap-2">
    <i class="pi pi-exclamation-triangle"></i>
    <span class="text-sm">
      {{ message }}
    </span>
  </div>
  <button
    pButton
    type="button"
    label="Reload"
    icon="pi pi-refresh"
    class="p-button-sm p-button-warning"
    (click)="onReloadClick()"
  ></button>
</div>
